import { useLayoutEffect, useRef } from "react";

import { HomePage } from "./torneos123/HomePage";
import { useHashScroll } from "./torneos123/hooks";
import { OrganizerPage } from "./torneos123/OrganizerPage";
import { PlayerPage } from "./torneos123/PlayerPage";
import { PrivacyPage } from "./torneos123/PrivacyPage";
import { SiteFooter } from "./torneos123/SiteFooter";
import { SiteHeader } from "./torneos123/SiteHeader";
import { StickyDemoBar } from "./torneos123/StickyDemoBar";
import { TournamentsPage } from "./torneos123/TournamentsPage";
import "./torneos123/landing.css";

export type PublicPage = "home" | "tournaments" | "organizer" | "player" | "privacy";

/** Clases en <html> mientras se ve una página pública: reservan el espacio del
 * encabezado fijo (arriba) y de la barra «Pedir demo» de /organizador (abajo)
 * para que el foco del teclado y los saltos a #anclas no queden tapados. Ver
 * landing.css. */
const HTML_PUBLIC_CLASS = "t123-public-html";
const HTML_ORGANIZER_CLASS = "t123-public-html--organizer";

/** Páginas públicas de torneos123.com: inicio, torneos abiertos, organizadores,
 * jugadores y aviso de privacidad (rediseño Eduardo 2026-09-29). */
export default function Torneos123LandingPage({ page = "home" }: { page?: PublicPage }) {
  const rootRef = useRef<HTMLDivElement>(null);

  // Antes del primer desplazamiento a #ancla (useHashScroll corre después).
  useLayoutEffect(() => {
    const html = document.documentElement;
    html.classList.add(HTML_PUBLIC_CLASS);
    html.classList.toggle(HTML_ORGANIZER_CLASS, page === "organizer");
    return () => html.classList.remove(HTML_PUBLIC_CLASS, HTML_ORGANIZER_CLASS);
  }, [page]);

  useHashScroll(rootRef);
  return (
    <div ref={rootRef} className="t123-page t123-page--reference" data-brand="torneos123-public-pages-v2">
      <SiteHeader page={page} />
      {page === "organizer" ? (
        <OrganizerPage />
      ) : page === "player" ? (
        <PlayerPage />
      ) : page === "tournaments" ? (
        <TournamentsPage />
      ) : page === "privacy" ? (
        <PrivacyPage />
      ) : (
        <HomePage />
      )}
      <SiteFooter page={page} />
      {page === "organizer" ? <StickyDemoBar /> : null}
    </div>
  );
}
